import { pageCtx } from './router';

import { CONFIG_OAUTH_UPDATE } from 'src/reducers/config/types';
import { LOADED_CONSENT_REQUEST, OAUTH_LOGO_UPDATE } from 'src/reducers/oauth/types';

import { urls } from 'Utilities/dataHelpers';
import mediator from 'Utilities/mediator';
import { getSessionObject, setSessionObject } from 'Utilities/storage';
import { store } from 'Utilities/store';

const oauthLogin = (ctx: pageCtx): void => {
  let challenge = '';

  if (ctx.query !== undefined && 'login_challenge' in ctx.query) {
    challenge = ctx.query.login_challenge as string;
    setSessionObject('login_challenge', ctx.query.login_challenge);
  } else {
    challenge = getSessionObject('login_challenge');
  }

  if (challenge?.length === 0) {
    // TODO: what do we do if there is no challenge to use?
  } else {
    mediator
      .request<OauthLoginResponse>('api:invoke', {
        method: 'GET',
        url: urls.lslApi + 'oauth2/api/login',
        query: {
          challenge,
        },
      })
      .then((result) => {
        if (result.status === 0 && result.data?.redirect_to) {
          window.location.assign(result.data.redirect_to);
          return;
        }

        // TODO: need to submit state message??

        const appLogo = result.data.client.dynamic_logo_uri;

        if (appLogo) {
          store.dispatch({ type: OAUTH_LOGO_UPDATE, appLogo });
        }

        if (result.status === 0) {
          if (result.data.skip) {
            // don't show the log in screen! should do the accept call instead
            mediator
              .request<OauthGen>('api:invoke', {
                method: 'PUT',
                url: urls.lslApi + 'oauth2/api/login/accept',
                data: {
                  challenge,
                  accountId: result.data.accountId,
                },
              })
              .then((result) => {
                if (result.status === 0) {
                  window.location.assign(result.data.redirect_to);
                }
              });
          } else {
            mediator.publish('app:ready', { state: true });
          }
        }
      });
  }
};

const oauthConsent = (ctx: pageCtx): void => {
  let challenge = '';

  if (ctx.query !== undefined && 'consent_challenge' in ctx.query) {
    challenge = ctx.query.consent_challenge as string;
    setSessionObject('consent_challenge', ctx.query.consent_challenge);
  } else {
    challenge = getSessionObject('consent_challenge');
  }

  if (challenge?.length === 0) {
    // TODO: what do we do if there is no challenge to use?
  } else {
    mediator
      .request<OauthConsentResponse>('api:invoke', {
        method: 'GET',
        url: urls.lslApi + 'oauth2/api/consent',
        query: {
          challenge,
        },
      })
      .then((result) => {
        if (result.status === 0 && result.data?.redirect_to) {
          window.location.assign(result.data.redirect_to);
          return;
        }

        // TODO: need to submit state message??

        const appLogo = result.data.client.dynamic_logo_uri;

        if (appLogo) {
          store.dispatch({ type: OAUTH_LOGO_UPDATE, appLogo });
        }

        if (result.status === 0) {
          if (result.data.skip) {
            // don't show the log in screen! should do the accept call instead
            mediator
              .request<OauthGen>('api:invoke', {
                method: 'PUT',
                url: urls.lslApi + 'oauth2/api/consent/accept',
                data: {
                  challenge,
                },
              })
              .then((result) => {
                if (result.status === 0) {
                  window.location.assign(result.data.redirect_to);
                }
              });
          } else {
            store.dispatch({
              type: LOADED_CONSENT_REQUEST,
              client: result.data.client,
              agreements: result.data.agreements,
              requestedScopes: result.data.requested_scopes,
              scopeDetails: result.data.scopeDetails,
              previousScopes: result.data.previous_scopes,
            });

            store.dispatch({
              type: CONFIG_OAUTH_UPDATE,
              privacyPolicy: result.data.config.privacyPolicy,
              termsOfUse: result.data.config.termsOfUse,
            });
            mediator.publish('app:ready', { state: true });
          }
        }
      });
  }
};

export const handlePaths = (ctx: pageCtx): boolean => {
  const actions = [
    {
      regex: [/^\/oauth\/login/i],
      action: oauthLogin,
    },
    {
      regex: [/^\/oauth\/consent/i],
      action: oauthConsent,
    },
  ];

  for (const check of actions) {
    for (const r of check.regex) {
      if (!!ctx.canonicalPath.match(r)) {
        check.action(ctx);
        return true;
      }
    }
  }

  return false;
};
